var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 240,
    viewBox: "0 0 279 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_5695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.05176e-05 237.569C-3.05176e-05 237.919 0.281303 238.201 0.631636 238.201H277.856C278.206 238.201 278.488 237.919 278.488 237.569C278.488 237.219 278.206 236.937 277.856 236.937H0.631636C0.281299 236.937 -3.05176e-05 237.219 -3.05176e-05 237.569Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4501 25.5057L93.4649 39.2625L87.0525 58.4106L76.7214 37.8375L78.1549 25.9022L90.4501 25.5057Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.025 38.55H76.187V60.1028H94.025V38.55Z",
    fill: "#7A51AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6897 32.4352C93.4177 32.4352 98.8718 26.9812 98.8718 20.2532C98.8718 13.5253 93.4177 8.07117 86.6897 8.07117C79.9618 8.07117 74.5077 13.5253 74.5077 20.2532C74.5077 26.9812 79.9618 32.4352 86.6897 32.4352Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0858 29.3118C76.0858 29.3118 67.0052 12.5416 75.1924 4.47131C83.3796 -3.59894 89.9518 1.71885 89.9518 1.71885L93.7048 1.56718C93.7048 1.56718 94.4876 4.52073 95.7497 2.92185C97.0118 1.32296 99.2926 7.14589 99.2926 7.14589C103.526 14.7695 88.8511 16.4773 88.8511 16.4773C88.8511 16.4773 89.9108 19.8528 88.8337 20.5597C87.7566 21.2666 84.8789 23.9258 84.8789 23.9258L82.3032 25.8712L80.7725 23.539C80.7725 23.539 79.1736 22.2768 78.3658 22.807C77.558 23.3372 78.6692 30.313 78.6692 30.313L76.0858 29.3118Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4717 152.688L56.8142 222.162L68.2639 222.55L83.4008 153.27L61.4717 152.688Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2227 152.299L84.5652 221.774L96.0149 222.162L111.152 152.881L89.2227 152.299Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6671 168.56L64.7623 92.8927L55.415 53.4909C54.6092 47.6338 58.2996 42.0918 63.9954 40.5806L73.1418 38.154L77.1902 34.1055L86.3983 54.4401L92.1492 34.121L96.6343 37.3829L109.936 43.2516L109.93 43.389L107.797 90.9862L112.56 167.887L112.348 167.889L58.6671 168.56Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2797 221.372L98.595 231.27C98.595 231.27 111.565 233.033 111.767 237.048C111.969 241.064 94.1398 238.739 83.6999 239.264C73.2599 239.789 81.9504 228.483 81.9504 228.483L83.0629 221.986L95.2797 221.372Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2052 220.66L71.5205 230.557C71.5205 230.557 84.4907 232.321 84.6925 236.336C84.8944 240.351 67.0653 238.027 56.6253 238.552C46.1854 239.076 54.8758 227.771 54.8758 227.771L55.9884 221.274L68.2052 220.66Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0303 128.374C51.8897 126.423 52.2186 124.466 52.9895 122.668L50.5151 102.37L60.2077 101.475L61.6738 122.161C62.6478 123.857 63.2016 125.762 63.2887 127.716C63.5737 132.603 61.2845 136.711 58.1752 136.892C55.0659 137.073 52.3146 133.26 52.0303 128.374Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.421 131.353C113.301 129.401 113.652 127.448 114.442 125.658L112.189 105.335L121.891 104.546L123.131 125.246C124.087 126.953 124.62 128.863 124.686 130.818C124.917 135.708 122.583 139.79 119.472 139.938C116.361 140.085 113.652 136.242 113.421 131.353Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4753 120.234L50.4425 120.059L45.3911 92.9555L51.3599 48.8202C51.8925 44.8799 55.4109 42.0414 59.3785 42.3587C61.4506 42.5245 63.3097 43.5073 64.6137 45.1262C65.9176 46.7452 66.4818 48.7711 66.2023 50.831L61.7099 83.9319L64.5384 119.336L50.4753 120.234Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.427 119.598L100.271 51.8051C99.7431 49.8172 100.052 47.7369 101.145 45.9692C102.239 44.2014 103.962 42.9961 105.998 42.575C109.892 41.7695 113.738 44.1502 114.755 47.9939L124.512 118.747L110.427 119.598Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 60.6371C87.3849 60.6371 87.9431 60.0789 87.9431 59.3903C87.9431 58.7017 87.3849 58.1434 86.6963 58.1434C86.0076 58.1434 85.4494 58.7017 85.4494 59.3903C85.4494 60.0789 86.0076 60.6371 86.6963 60.6371Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 70.0776C87.3849 70.0776 87.9431 69.5193 87.9431 68.8307C87.9431 68.1421 87.3849 67.5839 86.6963 67.5839C86.0076 67.5839 85.4494 68.1421 85.4494 68.8307C85.4494 69.5193 86.0076 70.0776 86.6963 70.0776Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 79.5181C87.3849 79.5181 87.9431 78.9599 87.9431 78.2713C87.9431 77.5826 87.3849 77.0244 86.6963 77.0244C86.0076 77.0244 85.4494 77.5826 85.4494 78.2713C85.4494 78.9599 86.0076 79.5181 86.6963 79.5181Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 88.9585C87.3849 88.9585 87.9431 88.4003 87.9431 87.7117C87.9431 87.0231 87.3849 86.4648 86.6963 86.4648C86.0076 86.4648 85.4494 87.0231 85.4494 87.7117C85.4494 88.4003 86.0076 88.9585 86.6963 88.9585Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 98.399C87.3849 98.399 87.9431 97.8407 87.9431 97.1521C87.9431 96.4635 87.3849 95.9053 86.6963 95.9053C86.0076 95.9053 85.4494 96.4635 85.4494 97.1521C85.4494 97.8407 86.0076 98.399 86.6963 98.399Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 107.84C87.3849 107.84 87.9431 107.281 87.9431 106.593C87.9431 105.904 87.3849 105.346 86.6963 105.346C86.0076 105.346 85.4494 105.904 85.4494 106.593C85.4494 107.281 86.0076 107.84 86.6963 107.84Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 117.28C87.3849 117.28 87.9431 116.722 87.9431 116.033C87.9431 115.344 87.3849 114.786 86.6963 114.786C86.0076 114.786 85.4494 115.344 85.4494 116.033C85.4494 116.722 86.0076 117.28 86.6963 117.28Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6963 126.72C87.3849 126.72 87.9431 126.162 87.9431 125.474C87.9431 124.785 87.3849 124.227 86.6963 124.227C86.0076 124.227 85.4494 124.785 85.4494 125.474C85.4494 126.162 86.0076 126.72 86.6963 126.72Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6977 134.023L63.1058 130.879L62.6515 130.819L50.5942 103.018L43.4137 86.4655H62.1168L86.6977 134.023Z",
    fill: "#7A51AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.289 28.5303L196.288 20.3134V43.7903H178.941L181.289 28.5303Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.504 33.7645L200.888 45.2902L190.911 65.1574L184.719 46.6663L187.63 33.3816L199.504 33.7645Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.404 45.9783H184.178V66.7915H201.404V45.9783Z",
    fill: "#7A51AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.614 156.199L220.112 223.29L209.055 223.665L194.438 156.761L215.614 156.199Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.816 155.824L193.313 222.915L182.256 223.29L167.639 156.387L188.816 155.824Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.296 170.429L227.033 170.428L156.595 170.198L156.658 169.949L174.768 98.1995L170.231 61.9902C169.372 55.129 173.045 48.6437 179.371 45.8528L181.655 44.8453L185.994 41.69L191.544 61.3032L200.433 41.6747L204.349 45.5897L213.179 47.9327C218.683 49.3928 222.249 54.748 221.473 60.3891L221.464 60.4284L207.979 98.9077L227.296 170.429Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.966 222.527L194.764 223.12L195.838 229.394C195.838 229.394 204.231 240.312 194.149 239.805C184.067 239.299 166.85 241.543 167.045 237.666C167.24 233.788 179.765 232.085 179.765 232.085L182.966 222.527Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.112 221.839L220.91 222.432L221.984 228.706C221.984 228.706 230.376 239.624 220.294 239.117C210.213 238.611 192.995 240.855 193.19 236.978C193.385 233.1 205.91 231.397 205.91 231.397L209.112 221.839Z",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.916 132.032C219.641 136.75 216.984 140.433 213.981 140.258C210.979 140.083 208.768 136.116 209.043 131.396C209.128 129.51 209.662 127.67 210.603 126.033L212.019 106.057L221.379 106.921L218.989 126.522C219.734 128.258 220.051 130.148 219.916 132.032Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.816 130.238C171.441 134.949 168.706 138.575 165.708 138.336C162.71 138.096 160.584 134.084 160.96 129.371C161.084 127.486 161.658 125.659 162.633 124.042L164.473 104.1L173.813 105.163L171.007 124.709C171.714 126.461 171.991 128.357 171.816 130.238Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.423 124.179L207.829 123.311L207.846 123.107L210.561 89.1149L206.223 57.1507C205.953 55.1598 206.498 53.2014 207.758 51.6366C209.019 50.0716 210.816 49.1216 212.819 48.9613C216.654 48.6589 220.055 51.3985 220.57 55.2071L226.334 97.829L226.328 97.8608L221.423 124.179Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.079 122.877L160.463 122.054L160.493 121.839L169.882 53.7444C170.869 50.0045 174.588 47.7041 178.351 48.4823C180.319 48.8893 181.984 50.0544 183.041 51.7632C184.098 53.4721 184.397 55.4827 183.882 57.425L174.079 122.877Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 67.3076C191.92 67.3076 192.459 66.7685 192.459 66.1035C192.459 65.4385 191.92 64.8994 191.255 64.8994C190.59 64.8994 190.051 65.4385 190.051 66.1035C190.051 66.7685 190.59 67.3076 191.255 67.3076Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 76.4241C191.92 76.4241 192.459 75.885 192.459 75.2201C192.459 74.5551 191.92 74.016 191.255 74.016C190.59 74.016 190.051 74.5551 190.051 75.2201C190.051 75.885 190.59 76.4241 191.255 76.4241Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 85.5406C191.92 85.5406 192.459 85.0015 192.459 84.3365C192.459 83.6715 191.92 83.1324 191.255 83.1324C190.59 83.1324 190.051 83.6715 190.051 84.3365C190.051 85.0015 190.59 85.5406 191.255 85.5406Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 94.6572C191.92 94.6572 192.459 94.1181 192.459 93.4531C192.459 92.7881 191.92 92.249 191.255 92.249C190.59 92.249 190.051 92.7881 190.051 93.4531C190.051 94.1181 190.59 94.6572 191.255 94.6572Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 103.774C191.92 103.774 192.459 103.235 192.459 102.57C192.459 101.905 191.92 101.365 191.255 101.365C190.59 101.365 190.051 101.905 190.051 102.57C190.051 103.235 190.59 103.774 191.255 103.774Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 112.89C191.92 112.89 192.459 112.351 192.459 111.686C192.459 111.021 191.92 110.482 191.255 110.482C190.59 110.482 190.051 111.021 190.051 111.686C190.051 112.351 190.59 112.89 191.255 112.89Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 122.007C191.92 122.007 192.459 121.468 192.459 120.803C192.459 120.138 191.92 119.599 191.255 119.599C190.59 119.599 190.051 120.138 190.051 120.803C190.051 121.468 190.59 122.007 191.255 122.007Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.255 131.123C191.92 131.123 192.459 130.584 192.459 129.919C192.459 129.254 191.92 128.715 191.255 128.715C190.59 128.715 190.051 129.254 190.051 129.919C190.051 130.584 190.59 131.123 191.255 131.123Z",
    fill: "#D6D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.083 39.6467C199.303 39.6467 204.346 34.6045 204.346 28.3845C204.346 22.1645 199.303 17.1222 193.083 17.1222C186.863 17.1222 181.821 22.1645 181.821 28.3845C181.821 34.6045 186.863 39.6467 193.083 39.6467Z",
    fill: "#FDB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.985 15.2372C199.525 16.3348 198.669 17.7058 197.536 18.1673C196.404 18.6287 195.124 18.4417 193.916 18.2497C192.708 18.0576 191.427 17.8754 190.298 18.3451C188.836 18.9527 188.013 20.477 187.303 21.8915C185.978 24.5321 184.653 27.1727 183.328 29.8133C182.68 31.1034 182.018 32.4516 182.006 33.895C181.983 36.5445 184.085 38.6619 185.216 41.058C186.592 43.9754 186.479 47.5508 184.92 50.3749C183.361 53.1991 180.395 55.2001 177.193 55.5894C176.35 55.6918 175.459 55.6807 174.701 55.2979C173.944 54.9151 173.365 54.0791 173.506 53.242C173.78 51.6047 176.282 51.2221 176.741 49.6268C176.981 48.7941 176.556 47.9047 175.984 47.2543C175.411 46.6038 174.687 46.0964 174.141 45.4236C172.881 43.8722 172.797 41.4773 173.945 39.8416C174.62 38.8802 175.663 38.166 176.099 37.0755C176.471 36.146 176.336 35.1012 176.195 34.1102C176.014 32.8367 175.833 31.5632 175.652 30.2896C175.441 28.8038 175.234 27.2648 175.651 25.8231C176.606 22.5195 180.336 20.968 182.524 18.3144C183.541 17.0812 184.224 15.5982 185.267 14.3873C187.017 12.3552 189.773 11.2342 192.444 11.4673C195.116 11.7003 197.635 13.2814 199.007 15.5858",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.207 15.4456C196.657 15.6423 196.453 16.359 196.611 16.9215C196.77 17.4839 197.184 17.9309 197.564 18.3751C201.858 23.3997 202.855 30.9999 200.005 36.9625C199.246 38.5485 198.236 40.0411 197.827 41.7508C197.53 42.9948 197.546 44.3594 196.856 45.4364C196.153 46.5328 194.761 47.2675 194.623 48.5625C194.535 49.3935 195.041 50.2007 195.72 50.6879C196.399 51.1751 197.229 51.3981 198.044 51.5798C200.164 52.0523 202.332 52.3102 204.504 52.3484C205.212 52.3608 205.943 52.3455 206.592 52.0634C207.242 51.7812 207.796 51.1694 207.804 50.4613C207.809 49.9047 207.488 49.3913 207.447 48.8363C207.325 47.1731 209.563 46.2883 209.999 44.6786C210.285 43.6203 209.721 42.5313 209.119 41.6147C208.517 40.6981 207.831 39.7356 207.846 38.6393C207.86 37.5898 208.518 36.6655 208.774 35.6475C209.128 34.2395 208.693 32.7668 208.262 31.3805C207.895 30.2019 207.528 29.0233 207.162 27.8448C206.772 26.5919 206.382 25.339 205.992 24.0862C205.311 21.8989 204.597 19.6483 203.124 17.894C201.65 16.1397 199.21 14.9899 197.034 15.7062",
    fill: "#2E2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.192 75.2329C198.192 75.2329 198.43 72.8424 200.999 71.4352C200.999 71.4352 204.018 69.6068 203.916 67.9994C203.916 67.9994 205.252 69.8999 203.555 71.8631C203.555 71.8631 202.598 73.017 200.941 73.3409C200.941 73.3409 199.329 73.548 198.192 75.2329Z",
    fill: "url(#paint0_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.737 74.2172C199.737 74.2172 201.823 73.0747 204.414 74.4391C204.414 74.4391 207.602 75.9448 208.857 74.9563C208.857 74.9563 208.055 77.144 205.499 76.8224C205.499 76.8224 204.02 76.6682 202.825 75.4603C202.825 75.4604 201.751 74.2248 199.737 74.2172Z",
    fill: "url(#paint1_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.225 75.054C198.225 75.054 198.639 72.6883 201.305 71.4802C201.305 71.4802 204.451 69.8864 204.468 68.2756C204.468 68.2756 205.66 70.2722 203.822 72.101C203.822 72.101 202.783 73.179 201.106 73.376C201.106 73.376 199.484 73.4601 198.225 75.054Z",
    fill: "url(#paint2_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.841 74.1584C199.841 74.1584 202.005 73.1776 204.488 74.735C204.488 74.735 207.556 76.4784 208.881 75.5882C208.881 75.5882 207.919 77.7087 205.394 77.194C205.394 77.194 203.93 76.9278 202.828 75.6325C202.828 75.6325 201.849 74.3191 199.841 74.1584Z",
    fill: "url(#paint3_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.577 76.2617C201.577 77.2624 200.776 78.0737 199.788 78.0737C198.801 78.0737 198 77.2624 198 76.2617C198 75.2608 198.801 74.4496 199.788 74.4496C200.776 74.4496 201.577 75.2608 201.577 76.2617Z",
    fill: "url(#paint4_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1921 68.2329C95.1921 68.2329 95.43 65.8424 97.999 64.4352C97.999 64.4352 101.018 62.6068 100.916 60.9994C100.916 60.9994 102.252 62.8999 100.555 64.8631C100.555 64.8631 99.5983 66.017 97.9412 66.3409C97.9412 66.3409 96.329 66.548 95.1921 68.2329Z",
    fill: "url(#paint5_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7365 67.2172C96.7365 67.2172 98.8225 66.0747 101.414 67.4391C101.414 67.4391 104.602 68.9448 105.857 67.9563C105.857 67.9563 105.055 70.144 102.499 69.8224C102.499 69.8224 101.02 69.6682 99.8248 68.4603C99.8248 68.4604 98.751 67.2248 96.7365 67.2172Z",
    fill: "url(#paint6_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2251 68.054C95.2251 68.054 95.6392 65.6883 98.3048 64.4802C98.3048 64.4802 101.451 62.8864 101.468 61.2756C101.468 61.2756 102.66 63.2722 100.822 65.101C100.822 65.101 99.7827 66.179 98.1062 66.376C98.1062 66.376 96.4836 66.4601 95.2251 68.054Z",
    fill: "url(#paint7_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8405 67.1584C96.8405 67.1584 99.005 66.1776 101.488 67.735C101.488 67.735 104.556 69.4784 105.881 68.5882C105.881 68.5882 104.919 70.7087 102.394 70.194C102.394 70.194 100.93 69.9278 99.8282 68.6325C99.8282 68.6325 98.8487 67.3191 96.8405 67.1584Z",
    fill: "url(#paint8_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5767 69.2617C98.5767 70.2624 97.7759 71.0737 96.7883 71.0737C95.8007 71.0737 95.0001 70.2624 95.0001 69.2617C95.0001 68.2608 95.8007 67.4496 96.7883 67.4496C97.7759 67.4496 98.5767 68.2608 98.5767 69.2617Z",
    fill: "url(#paint9_linear_1023_5695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.882 59.0869L204.11 58.862C205.718 53.3478 202.25 43.0576 202.215 42.9543L202.976 42.6948C203.124 43.1265 206.561 53.3313 204.882 59.0869Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.496 65.4205C206.351 65.4205 207.855 63.9168 207.855 62.0618C207.855 60.2069 206.351 58.7031 204.496 58.7031C202.641 58.7031 201.137 60.2069 201.137 62.0618C201.137 63.9168 202.641 65.4205 204.496 65.4205Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.427 73.9527H180.39C180.168 73.9527 179.988 73.7727 179.988 73.5507C179.988 73.3287 180.168 73.1486 180.39 73.1486H182.427C182.988 73.1486 183.516 72.93 183.912 72.5326C184.308 72.1355 184.526 71.6076 184.525 71.0466L184.5 58.5002C184.5 55.7746 182.284 53.5579 179.559 53.5579C176.834 53.5579 174.617 55.7746 174.617 58.4994L174.642 70.2429C174.644 71.3885 175.578 72.3277 176.724 72.3365L178.122 72.3471C178.344 72.3489 178.522 72.5301 178.521 72.7523C178.519 72.9731 178.339 73.1512 178.119 73.1512H178.116L176.718 73.1406C175.133 73.1284 173.841 71.8291 173.838 70.2444L173.813 58.5002C173.813 55.3313 176.39 52.7538 179.559 52.7538C182.727 52.7538 185.305 55.3313 185.305 58.4994L185.329 71.045C185.331 71.8212 185.03 72.5513 184.481 73.1006C183.933 73.65 183.203 73.9527 182.427 73.9527Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.119 74.1742C178.906 74.1742 179.544 73.5362 179.544 72.7492C179.544 71.9622 178.906 71.3242 178.119 71.3242C177.332 71.3242 176.694 71.9622 176.694 72.7492C176.694 73.5362 177.332 74.1742 178.119 74.1742Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.39 74.9757C181.177 74.9757 181.815 74.3377 181.815 73.5507C181.815 72.7637 181.177 72.1257 180.39 72.1257C179.603 72.1257 178.965 72.7637 178.965 73.5507C178.965 74.3377 179.603 74.9757 180.39 74.9757Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1272 53.0605L97.3553 52.8355C98.9635 47.3214 95.5349 36.8718 95.4999 36.7686L96.4648 37.4959C96.612 37.9276 99.8061 47.3049 98.1272 53.0605Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9933 54.0402L71.7652 53.8152C70.157 48.301 73.6246 38.0108 73.6596 37.9076L72.8339 38.4607C72.6866 38.8924 69.3145 48.2845 70.9933 54.0402Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7413 59.3942C99.5963 59.3942 101.1 57.8904 101.1 56.0355C101.1 54.1805 99.5963 52.6768 97.7413 52.6768C95.8863 52.6768 94.3826 54.1805 94.3826 56.0355C94.3826 57.8904 95.8863 59.3942 97.7413 59.3942Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5741 74.6949H72.5371C72.3149 74.6949 72.1351 74.5149 72.1351 74.2929C72.1351 74.0709 72.3149 73.8908 72.5371 73.8908H74.5741C75.1355 73.8908 75.6628 73.6721 76.0593 73.2748C76.4555 72.8777 76.6734 72.3498 76.6722 71.7887L76.6475 59.2424C76.6475 56.5168 74.4308 54.3001 71.706 54.3001C68.9812 54.3001 66.764 56.5168 66.764 59.2416L66.7888 70.9851C66.7911 72.1307 67.7252 73.0699 68.8708 73.0787L70.269 73.0893C70.4908 73.0911 70.6694 73.2723 70.6679 73.4945C70.6663 73.7153 70.4865 73.8934 70.2658 73.8934H70.2627L68.8646 73.8828C67.2799 73.8706 65.9878 72.5712 65.9847 70.9866L65.96 59.2424C65.96 56.0735 68.5375 53.496 71.706 53.496C74.874 53.496 77.4516 56.0735 77.4516 59.2416L77.4763 71.7872C77.4779 72.5634 77.1767 73.2935 76.6282 73.8427C76.0801 74.3922 75.3503 74.6949 74.5741 74.6949Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.266 74.9164C71.053 74.9164 71.691 74.2784 71.691 73.4914C71.691 72.7044 71.053 72.0664 70.266 72.0664C69.479 72.0664 68.841 72.7044 68.841 73.4914C68.841 74.2784 69.479 74.9164 70.266 74.9164Z",
    fill: "#3F3C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.537 75.7179C73.324 75.7179 73.962 75.0799 73.962 74.2929C73.962 73.5059 73.324 72.8679 72.537 72.8679C71.75 72.8679 71.1121 73.5059 71.1121 74.2929C71.1121 75.0799 71.75 75.7179 72.537 75.7179Z",
    fill: "#3F3C57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_5695",
    x1: 198.192,
    y1: 75.2329,
    x2: 204.416,
    y2: 75.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_5695",
    x1: 199.737,
    y1: 76.8547,
    x2: 208.857,
    y2: 76.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_5695",
    x1: 200.044,
    y1: 72.2129,
    x2: 201.93,
    y2: 74.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_5695",
    x1: 194.613,
    y1: 73.234,
    x2: 195.466,
    y2: 79.2663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1023_5695",
    x1: 199.134,
    y1: 73.7859,
    x2: 197.309,
    y2: 76.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1023_5695",
    x1: 95.1921,
    y1: 68.2329,
    x2: 101.416,
    y2: 68.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1023_5695",
    x1: 96.7365,
    y1: 69.8547,
    x2: 105.857,
    y2: 69.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1023_5695",
    x1: 97.0442,
    y1: 65.2129,
    x2: 98.9296,
    y2: 67.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1023_5695",
    x1: 91.6131,
    y1: 66.234,
    x2: 92.4655,
    y2: 72.2663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1023_5695",
    x1: 96.1337,
    y1: 66.7859,
    x2: 94.3095,
    y2: 69.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_5695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278.488,
    height: 240,
    fill: "white",
    transform: "translate(-3.05176e-05 -0.000244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDr);
export default __webpack_public_path__ + "static/media/noDr.8fa841fc39b8b79bd0e75c61bfde2c7b.svg";
export { ForwardRef as ReactComponent };